

export default () => {
    let item = $(".blogs-slider-mobile .blog-slider-wrapper .item").length;
    let x = 4; // 4 items visible

    $('.blogs-slider-mobile .blog-slider-wrapper .item:lt('+x+')').show();
    $('.blogs-slider-mobile .btn-more').off('click').click(function () {
        x = (x+5 <= item) ? x+5 : item;
        $('.blogs-slider-mobile .blog-slider-wrapper .item:lt('+x+')').slideDown("fast");
        $('.blogs-slider-mobile .btn-more').show("fast");

        if(x == item){
            $('.blogs-slider-mobile .btn-more').hide();
            $('.blogs-slider-mobile .opacity-item').hide();
        }
    });
}
